
import { Component, Emit, Vue } from "vue-property-decorator";
import { Email, EmailType, Nullable } from "@gsx/common";
import FormSelect from "../../../form/FormSelect.vue";
import ActionButton from "../../../../../../common/src/components/ActionButton.vue";
import Modal from "../../../../../../common/src/components/Modal.vue";
import FormInput from "../../../form/FormInput.vue";
import FormTextarea from "../../../form/FormTextarea.vue";

@Component({
    components: {
        FormTextarea,
        FormInput,
        ActionButton,
        FormSelect,
        Modal,
    },
})
export default class AddEmailModal extends Vue {
    comments: string | null = null;
    email: string | null = null;
    type: EmailType | null = null;

    get emailTypes(): EmailType[] {
        return Object.values(EmailType);
    }

    @Emit()
    submit(): Nullable<Email> {
        return {
            comments: this.comments,
            email: this.email,
            type: this.type,
        };
    }

    @Emit()
    close() {
        //
    }

    async onSubmit() {
        this.submit();
        this.close();
    }
}
